import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from '@gasbuddy/react';
import { FlexGrid, Button, Text } from '@gasbuddy/react-components';
import ReactTooltip from 'react-tooltip';

import Card from '../../components/card';
import StationProfileMap from '../../components/maps/station-profile';
import WatchStation from '../../components/watch-station';
import BrandViewContent from '../../components/station-profile-tab/station-brands/brand-view-content';
import StationPropTypes from '../../utils/prop-types/station';
import { computeClosingHour, getStatusDisplayName } from '../../components/station-profile-tab/station-status/helper';
import styles from './styles.css';

const { gTagEvent } = require('../../../lib/global-site-tag').default;

const StationBanner = ({ station, isLoading }) => {
  const closingHour = computeClosingHour(station.opening_hours);
  const openStatus = station.open_status;

  const onClickViewLiveListing = (stationId) => {
    gTagEvent('Banner Card', 'View Live Listing', { station_id: stationId });
  };

  const onClickWatch = (stationId, watched) => {
    gTagEvent('Banner Card', `${!watched ? 'Watched' : 'Un-watched'} Station`);
  };

  return (
    <Card
      title={(
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <span onClick={() => onClickWatch(station.id, station.watched)}>
          <WatchStation stationId={station.id} isWatched={station.watched} iconHeight={28} tooltip />
          {
            <>
              <span data-tip data-for={`station-name-${station.retailer_name}`}>
                {`${station.retailer_name} - #${station.retailer_reference}`}
              </span>
              <ReactTooltip id={`station-name-${station.retailer_name}`} place="top" effect="solid">
                {`This station was last updated at ${moment(station.update_date).format('MMM Do YYYY, h:mm:ss a')}`}
              </ReactTooltip>
            </>
          }
        </span>
      )}
      largeTitle
      isLoading={isLoading}
    >
      <div className={styles.bannerMainCard}>
        <FlexGrid>
          <FlexGrid.Column key="Address" tablet={4}>
            <div className={styles.bannerContent}>
              <BrandViewContent
                hideBrandInfo
              />
            </div>
            <div className={styles.bannerContent}>
              <div>{`${station.address.address}`}</div>
              <div>{`${station.address.city}, ${station.address.state}, ${station.address.zip}`}</div>
              <div>{`${station.phone_number}`}</div>
            </div>
            <div className={styles.bannerContent}>
              <h5 className={styles.bannerHoursTitle}>{getStatusDisplayName(openStatus)}</h5>
              {openStatus === 'open'
                && <Text className={styles.bannerHoursToday}>{closingHour}</Text>
              }
            </div>
            <div className={styles.bannerContent}>
              <form action={`https://www.gasbuddy.com/station/${station.id}`} target="_blank">
                <Button
                  type="submit"
                  rounded
                  color="red"
                  wide
                  style={{ marginTop: '15px' }}
                  onClick={() => onClickViewLiveListing(station.id)}
                >
                  VIEW LIVE LISTING
                </Button>
              </form>
            </div>
          </FlexGrid.Column>
          <FlexGrid.Column key="Map" tablet={8}>
            <StationProfileMap station={station} />
          </FlexGrid.Column>
        </FlexGrid>
      </div>
    </Card>
  );
};

StationBanner.propTypes = {
  station: StationPropTypes.isRequired,
  isLoading: PropTypes.bool,
};

StationBanner.defaultProps = {
  isLoading: false,
};

const mapStateToProps = state => ({
  station: state.station,
  isLoading: state.loading,
});

export default connect(mapStateToProps)(StationBanner);
